//Front-end (show/hide UI)
export const FeatureProductImport = "product-import"
export const FeatureContactImport = "contact-import"
export const FeatureInventorySync = "inventory-sync"
export const FeaturePurchaseOrderTracking = "purchase-order-tracking"
export const EnableHiddenFeatures = "enable-hidden-features"
export const EnableInboxFeature = "enable-inbox-feature"
export const FeatureProductInventorySync = "product-inventory-sync"

//Payments
export const FeaturePaymentSync = "payment-sync"
export const FeatureCreateCreditMemoPaymentImport = "payment-import-create-credit-memo"
export const FeatureExternalCheckoutPayment = "external-checkout-payment"
export const FeatureFullPaymentAndCheckoutOnly = "full-payment-and-checkout-only"
export const FeatureIntegratedPaymentSEPA = "integrated-payment-sepa-debit"

// Quotes
export const FeatureApprovedQuoteAutoExport = "approved-quote-auto-export"
export const FeatureProposedQuote = "proposed-quote-export"
// Orders
export const FeatureExportOrderLineDetailsToPurchaseOrder = "export-order-line-details-to-purchase-order"

// Invoices
export const FeatureInvoiceCronImport = "invoice-sync"
export const FeatureSentInvoiceAutoExport = "sent-invoice-auto-export"
export const FeatureSentInvoiceExport = "sent-invoice-export"
export const FeatureOverrideInvoiceNumber = "override-invoice-number"

// Products
export const FeatureProductSync = "product-sync"
export const FeatureProductExport = "product-export"
export const FeatureProductImportIgnoreSkuMatching = "product-import-ignore-sku-matching"
export const FeatureShortDescriptionProductImport = "short-description-product-import"

// Inventory
export const FeatureInventoryCronImport = "inventory-cron-import"
export const FeatureInventoryLevel = "inventory-level"

// Contacts
export const FeatureContactExport = "contact-export"
export const FeatureExportOrganizationsOnInvoices = "export-organizations-on-invoices"

// Misc
export const FeatureExternalPricingCalculation = "external-pricing-calculation"

//External order
export const FeatureExternalOrderCronImport = "external-order-cron-import"

//Ecommerce Configuration
export const FeatureEcommerceConfiguration = "ecommerce-configuration"


// WEBPACK FOOTER //
// ./src/state/integration/IntegrationFeatureKeys.ts